module.exports = __webpack_public_path__ + "static/logo-ff.1112f440.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/logo-ff.png
// module id = 541
// module chunks = 1